import * as fromDatatype from '../datatype-library/index'

export interface bl_mrp_job_template_to_process_template_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    process_template_hdr_guid: fromDatatype.GuidDataFieldInterface;
    descr: fromDatatype.TextDatatypeInterface;
    sequence_no: fromDatatype.NumericDatatypeInterface;
    ratio: fromDatatype.NumericDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision:  fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    parent_guid: fromDatatype.GuidDataFieldInterface;
    level_int: fromDatatype.IntegerDatatypeInterface;
    process_template_bom_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    group_name: fromDatatype.VarcharDatatypeInterface;
    output_inv_item_guid : fromDatatype.GuidDataFieldInterface;
    reverse_level_int: fromDatatype.NumericDatatypeInterface;
};

export class bl_mrp_job_template_to_process_template_link_RowClass implements bl_mrp_job_template_to_process_template_link_RowInterface
  {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    process_template_hdr_guid: fromDatatype.GuidDataFieldInterface;
    descr: fromDatatype.TextDatatypeInterface;
    sequence_no: fromDatatype.NumericDatatypeInterface;
    ratio: fromDatatype.NumericDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision:  fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    parent_guid: fromDatatype.GuidDataFieldInterface;
    level_int: fromDatatype.IntegerDatatypeInterface;
    process_template_bom_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    group_name: fromDatatype.VarcharDatatypeInterface;
    output_inv_item_guid : fromDatatype.GuidDataFieldInterface;
    reverse_level_int: fromDatatype.NumericDatatypeInterface;
  }
